/* ───────────────────────────────────────────────────────────────────────────
   VitalVac funnel tracking — v1.0

   Answers three questions per landing page:
     1. how many people go through          → view, engaged time, CTA click-through
     2. where they leave                    → scroll depth tagged with the section
                                              heading reached, plus an exit beacon
     3. what they click                     → every CTA, its label, its position in
                                              the page, and the scroll % at click

   Emits to whatever the host provides and no-ops on the rest:
     Shopify.analytics.publish  →  a custom pixel in Settings > Customer events
     window.dataLayer           →  Google Tag Manager
     gtag                       →  GA4 direct
     fbq                        →  Meta custom events
     clarity                    →  Microsoft Clarity custom tags
     VV_TRACK_ENDPOINT          →  your own collector, if you set one

   Self-contained, no dependencies, guards against double-init, and never throws
   into the page — every emit is wrapped.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  if (window.__vvTrack) return;            // injected twice (page + layout) is fine
  window.__vvTrack = true;

  var PAGE = window.VV_PAGE || document.body.getAttribute('data-vv-page') || 'unknown';
  var NS = 'vv';
  var START = Date.now();
  var ENDPOINT = window.VV_TRACK_ENDPOINT || null;

  /* ── session + attribution ────────────────────────────────────────────── */
  function uid() {
    try {
      var k = 'vv_sid', v = sessionStorage.getItem(k);
      if (!v) {
        v = (Date.now().toString(36) + Math.random().toString(36).slice(2, 8));
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return 'nostore'; }
  }
  var SID = uid();

  var qs = {};
  try {
    new URLSearchParams(location.search).forEach(function (v, k) { qs[k] = v; });
  } catch (e) {}

  function base(extra) {
    var d = {
      page: PAGE,
      session_id: SID,
      href: location.pathname,
      referrer: document.referrer || '',
      viewport: window.innerWidth + 'x' + window.innerHeight,
      utm_source: qs.utm_source || '',
      utm_medium: qs.utm_medium || '',
      utm_campaign: qs.utm_campaign || '',
      utm_content: qs.utm_content || '',
      seconds: Math.round((Date.now() - START) / 1000),
      engaged_seconds: engaged
    };
    for (var k in (extra || {})) d[k] = extra[k];
    return d;
  }

  /* ── emit ─────────────────────────────────────────────────────────────── */
  function emit(name, data, beacon) {
    var full = NS + ':' + name;
    var payload = base(data);

    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish)
            Shopify.analytics.publish(full, payload); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(
            Object.assign({ event: full }, payload)); } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', name, payload); } catch (e) {}
    try { if (typeof fbq === 'function') fbq('trackCustom', 'VV' +
            name.replace(/(^|_)(\w)/g, function (_, a, b) { return b.toUpperCase(); }),
            payload); } catch (e) {}
    try { if (typeof clarity === 'function') {
            clarity('set', 'vv_page', PAGE);
            if (data && data.cta_label) clarity('set', 'vv_last_cta', String(data.cta_label).slice(0, 60));
            if (data && data.depth) clarity('set', 'vv_depth', String(data.depth));
          } } catch (e) {}

    if (ENDPOINT) {
      try {
        var body = JSON.stringify(Object.assign({ event: full }, payload));
        if (beacon && navigator.sendBeacon) {
          navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
        } else {
          fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true,
                            headers: { 'Content-Type': 'application/json' } });
        }
      } catch (e) {}
    }
    if (window.VV_DEBUG) console.log('[vv]', full, payload);
  }

  /* ── sections: use the page's own headings as the map ─────────────────── */
  var sections = [];
  function indexSections() {
    sections = [].slice.call(document.querySelectorAll('h1, h2, h3'))
      .filter(function (h) { return (h.textContent || '').trim().length > 3; })
      .map(function (h, i) {
        return { i: i, el: h, label: (h.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 70) };
      });
  }

  function currentSection() {
    var y = window.scrollY + window.innerHeight * 0.4, last = null;
    for (var i = 0; i < sections.length; i++) {
      var top = sections[i].el.getBoundingClientRect().top + window.scrollY;
      if (top <= y) last = sections[i]; else break;
    }
    return last;
  }

  /* ── scroll depth ─────────────────────────────────────────────────────── */
  var THRESHOLDS = [10, 25, 50, 75, 90, 100];
  var hit = {}, maxDepth = 0, lastSectionSeen = '';

  /* A page that is not scrollable is NOT a page that has been fully read — it is
     usually a page that has not laid out yet (images still loading, or a zero-
     height viewport). Reporting 100% there fires every threshold on load and
     destroys the drop-off data, so measurement is held until the document is
     genuinely measurable. A page whose content really does fit the viewport is
     handled once, after load, by settle(). */
  function measurable() {
    return window.innerHeight > 0 && document.documentElement.scrollHeight > 0;
  }

  function depthNow() {
    if (!measurable()) return 0;
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return 0;
    return Math.min(100, Math.round((window.scrollY / scrollable) * 100));
  }

  function onScroll() {
    if (!measurable()) return;
    var d = depthNow();
    if (d > maxDepth) maxDepth = d;
    var s = currentSection();
    if (s) lastSectionSeen = s.label;
    for (var i = 0; i < THRESHOLDS.length; i++) {
      var t = THRESHOLDS[i];
      if (d >= t && !hit[t]) {
        hit[t] = true;
        emit('scroll_depth', { depth: t, section: lastSectionSeen,
                               section_index: s ? s.i : -1 });
      }
    }
  }

  /* Images and webfonts change the page height after DOMContentLoaded, which
     moves every section boundary — so re-index once things settle. */
  function settle() {
    indexSections();
    if (measurable() &&
        document.documentElement.scrollHeight <= window.innerHeight &&
        !hit[100]) {
      // content genuinely fits the viewport: they have seen all of it
      for (var i = 0; i < THRESHOLDS.length; i++) hit[THRESHOLDS[i]] = true;
      maxDepth = 100;
      var s = currentSection();
      emit('scroll_depth', { depth: 100, section: s ? s.label : '',
                             section_index: s ? s.i : -1, fits_viewport: 1 });
    } else {
      onScroll();
    }
  }

  /* ── engaged time: only count while visible and actually interacting ──── */
  var engaged = 0, lastActive = Date.now(), IDLE = 15000;
  function markActive() { lastActive = Date.now(); }
  setInterval(function () {
    if (document.visibilityState === 'visible' && Date.now() - lastActive < IDLE) engaged++;
  }, 1000);

  /* ── CTA clicks ───────────────────────────────────────────────────────── */
  function ctaInfo(a) {
    var all = [].slice.call(document.querySelectorAll('a[href]'));
    var s = currentSection();
    return {
      cta_label: (a.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 60),
      cta_index: all.indexOf(a) + 1,
      cta_total: all.length,
      cta_href: a.getAttribute('href') || '',
      cta_is_product: /firstaiddevices\.com\/products/.test(a.href) ? 1 : 0,
      depth_at_click: depthNow(),
      section: s ? s.label : '',
      section_index: s ? s.i : -1
    };
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var info = ctaInfo(a);
    emit(info.cta_is_product ? 'cta_click' : 'link_click', info);
  }, true);

  /* ── stamp product links so orders tie back to this page ──────────────── */
  function tagProductLinks() {
    var n = 0;
    [].slice.call(document.querySelectorAll('a[href]')).forEach(function (a, i) {
      if (!/firstaiddevices\.com\/products/.test(a.href)) return;
      try {
        var u = new URL(a.href);
        if (!u.searchParams.get('ref')) u.searchParams.set('ref', PAGE);
        // carry the ad click's attribution through to the store
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
         'fbclid', 'ttclid', 'gclid'].forEach(function (k) {
          if (qs[k] && !u.searchParams.get(k)) u.searchParams.set(k, qs[k]);
        });
        if (!u.searchParams.get('utm_content')) u.searchParams.set('utm_content', 'cta-' + (i + 1));
        a.href = u.toString();
        n++;
      } catch (err) {}
    });
    return n;
  }

  /* ── exit: one beacon with the whole story ────────────────────────────── */
  var sent = false;
  function sendExit(reason) {
    if (sent) return;
    sent = true;
    emit('exit', {
      reason: reason,
      max_depth: maxDepth,
      last_section: lastSectionSeen,
      reached_end: maxDepth >= 90 ? 1 : 0,
      clicked_cta: clickedCta
    }, true);
  }
  var clickedCta = 0;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a && /firstaiddevices\.com\/products/.test(a.href)) clickedCta = 1;
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') sendExit('hidden');
  });
  window.addEventListener('pagehide', function () { sendExit('pagehide'); });

  /* ── go ───────────────────────────────────────────────────────────────── */
  function init() {
    indexSections();
    var tagged = tagProductLinks();
    emit('page_view', { sections: sections.length, product_links: tagged });
    onScroll();
    window.addEventListener('load', settle);
    window.addEventListener('resize', function () { indexSections(); onScroll(); },
                            { passive: true });
    setTimeout(settle, 1200);            // covers lazy images on a slow connection
    /* Throttle on a timestamp, not requestAnimationFrame. rAF is suspended
       whenever the tab is not painting — background tabs, some in-app webviews,
       battery saver — and a scroll handler that never runs means no depth data
       and an exit beacon that reports 0% for a reader who got to the bottom.
       A trailing timeout guarantees the final position is always recorded. */
    var lastRun = 0, trailing = null, MIN_GAP = 150;
    window.addEventListener('scroll', function () {
      markActive();
      var now = Date.now();
      if (now - lastRun >= MIN_GAP) {
        lastRun = now;
        onScroll();
      } else if (!trailing) {
        trailing = setTimeout(function () {
          trailing = null; lastRun = Date.now(); onScroll();
        }, MIN_GAP);
      }
    }, { passive: true });
    ['mousemove', 'keydown', 'touchstart', 'click'].forEach(function (ev) {
      window.addEventListener(ev, markActive, { passive: true });
    });
    // periodic heartbeat so you can see drop-off even without an exit event
    setInterval(function () {
      if (document.visibilityState === 'visible')
        emit('heartbeat', { max_depth: maxDepth, last_section: lastSectionSeen });
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
})();
